const actions = {
  // Integração Etregas

  listarProdutosIntegracao: async (
    context,
    {
      apenas_soc,
      enviado,
      erros,
      per_page,
      unidade_id,
      page,
      requisicao_id,
      data_inicial,
      data_final,
      solicitante,
      produto,
      epi,
      download,
      mensagem_erros,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/requisicoes`, {
      params: {
        apenas_soc,
        enviado,
        erros,
        per_page,
        data_inicial,
        data_final,
        solicitante,
        produto,
        unidade_id,
        page,
        requisicao_id,
        epi,
        download,
        mensagem_erros,
      },
    });

    return response;
  },

  integrarProduto: async (context, { job, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`integracao/jobs`, {
      job,
      payload: { id },
    });

    return response;
  },

  reprocessarJob: async (context, { integrationConsumptionIds }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`integracao/consumo/reprocessar`, {
      integrationConsumptionIds,
    });

    return response;
  },

  integrarProdutoCerradinhoEnvio: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integrations/products/consume/synchronize`);

    return response;
  },

  integrarProdutoCerradinhoReenvio: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integrations/products/consume/synchronize`);

    return response;
  },

  //Integração Produtos

  listarProdutos: async (context, { vendor_id, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${vendor_id}/products`, {
      params: {
        page,
        per_page,
        search,
      },
    });

    return response;
  },

  listarEpisIntegracao: async (
    context,
    { per_page, page, nome, possui_codigo_epi, unidade_codigo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/epis`, {
      params: {
        page,
        per_page,
        nome,
        possui_codigo_epi,
        unidade_codigo,
      },
    });

    return response;
  },

  atualizarIntegracao: async (context, { vendor_id, job }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`integracao/jobs`, {
      job,
      payload: { vendor_id },
    });

    return response;
  },

  atualizarCodigoEpi: async (context, { codigo_epi, epi_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`integracao/epis/${epi_id}`, {
      codigo_epi,
    });

    return response;
  },

  duplicar: async (context, { codigo_epi, product_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`integracao/epis/${product_id}/duplicar`, {
      codigo_epi,
    });

    return response;
  },

  // Integração Postos

  listarUnidades: async (context, { per_page, search, vendor_id = "" }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/configuracao`, {
      params: {
        per_page,
        search,
        vendor_id,
      },
    });

    return response;
  },
  atualizarUnidade: async (
    context,
    {
      vendor_id,
      ativo,
      centro,
      codigoCentroCusto,
      deposito,
      descarga,
      diasNecessidade,
      recebedor,
      requisitante,
      planta,
      providerId,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`integracao/configuracao`, {
      parametros: {
        ativo,
        centro,
        codigoCentroCusto,
        deposito,
        descarga,
        diasNecessidade,
        planta,
        providerId,
        recebedor,
        requisitante,
      },
      vendor_id,
    });

    return response;
  },

  // Integração Usuários

  listarUsuarios: async (
    context,
    { per_page, page, nome, matricula, unidade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/funcionarios`, {
      params: {
        per_page,
        page,
        nome,
        matricula,
        unidade,
      },
    });

    return response;
  },

  // Cadastrar Produtos
  cadastrarProduto: async (
    context,
    {
      id,
      code,
      name,
      codigo_integracao,
      codigo_integracao_ca,
      ca_id,
      description,
      measurement_unit,
      measurement_unit_description,
      product_category_id,
      product_group_id,
      price,
      is_epi,
      contrato_ca_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`integracao/epis/cadastro-completo`, {
      id,
      code,
      name,
      codigo_integracao,
      codigo_integracao_ca,
      ca_id,
      description,
      unidade: { measurement_unit, measurement_unit_description },
      contrato: {
        product_category_id,
        product_group_id,
        price,
        is_epi,
        ca_id: contrato_ca_id,
      },
    });

    return response;
  },

  listarCategorias: async (context, { nome, per_page, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = api.get(`product-categories`, {
      params: {
        per_page,
        page,
        nome,
      },
    });

    return response;
  },

  listarCas: async (context, { per_page, code, page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cas`, {
      params: {
        per_page,
        code,
        page,
      },
    });
    return response;
  },

  listarGrupos: async (context, { vendor_id, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups`, {
      params: {
        page,
        per_page,
        vendor_id,
        search,
      },
    });

    return response;
  },

  receberDadosIntegracao: async (
    context,
    { nome, per_page, possui_codigo_epi = 1, unidade_codigo }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`integracao/epis`, {
      params: {
        nome,
        per_page,
        possui_codigo_epi,
        unidade_codigo,
      },
    });

    return response;
  },

  //Logs Integração
  receberLogsIntegracao: async (
    context,
    { data_inicial, data_final, per_page, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/funcionarios/log`, {
      params: {
        data_inicial,
        data_final,
        per_page,
        page,
      },
    });

    return response;
  },

  estoque: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`integracao/cerradinho/atualizacao-estoque`);

    return response;
  },

  produtos: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`integracao/cerradinho/sync-produtos`);

    return response;
  },

  listarClientes: async (context, { id_vendor }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendor-integracao-cliente`, {
      params: {
        id_vendor,
      },
    });

    return response;
  },

  excluirCliente: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`vendor-integracao-cliente/${id}`);

    return response;
  },

  criarCliente: async (
    context,
    {
      tipo_venda,
      codigo_filial,
      codigo_praca,
      status,
      id_plano_pagamento,
      id_cliente,
      id_vendor,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`vendor-integracao-cliente`, {
      tipo_venda,
      codigo_filial,
      codigo_praca,
      status,
      id_plano_pagamento,
      id_cliente,
      id_vendor,
    });

    return response;
  },

  editarCliente: async (
    context,
    {
      id_vendor,
      id_cliente,
      id_plano_pagamento,
      tipo_venda,
      codigo_filial,
      codigo_praca,

      status,
      id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vendor-integracao-cliente/${id}`, {
      id_vendor,
      id_cliente,
      id_plano_pagamento,
      tipo_venda,
      codigo_filial,
      codigo_praca,

      status,
    });

    return response;
  },

  listarCentrosCustos: async (context, { vendor_id, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`cost-centers`, {
      params: {
        vendor_id,
        per_page,
        search,
      },
    });

    return response;
  },

  listarCentrosPlanta: async (context, { cost_center_code }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`cost-center-branch`, {
      params: {
        cost_center_code,
      },
    });

    return response;
  },

  removerCentro: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`cost-center-branch/${id}`);

    return response;
  },

  editarCentro: async (
    context,
    {
      cost_center_id,
      cost_center_code,
      branch_code,
      cost_center_name,
      vendor_name,
      vendor_id,
      id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`cost-center-branch/${id}`, {
      vendor_id,
      vendor_name,
      cost_center_id,
      branch_code,
      cost_center_code,
      cost_center_name,
    });

    return response;
  },

  criarCentro: async (context, { vendor_id, cost_center_id, branch_code }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`cost-center-branch`, {
      vendor_id,
      cost_center_id,
      branch_code,
    });

    return response;
  },

  getLogsArquivosBraskem: async (
    context,
    {
      codigo_integracao_empresa,
      unidade_id,
      nome_arquivo,
      status,
      data_inicial,
      data_final,
      page,
      per_page,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`integracao/logs-braskem`, {
      params: {
        codigo_integracao_empresa,
        unidade_id,
        nome_arquivo,
        status,
        data_inicial,
        data_final,
        page,
        per_page,
      },
    });

    return response;
  },
};

export const integracao = {
  namespaced: true,
  actions,
};
